import logo from './logo.svg';
import './App.css';
import Navbar from './components/Navbar';
import Home from './components/Home';
import About from './components/About';
import Resume from './components/Resume';
import { Heading, Text } from '@chakra-ui/react';
import Skill from './components/Skill';
import Project from './components/Project';
import Contact from './components/Contact';
import Github from './components/Github';

function App() {
  return (
    <div className="App" style={{backgroundColor:"black"}}>
      
      <Navbar/>
      <Home/>
      {/* <Heading  color={"red.600"}>About Me</Heading> */}
      <About/>

      {/* <Heading   color={"red.900"}>Skills</Heading> */}
      <Skill/>
      {/* <Heading  color={"red.900"}>My Projects</Heading> */}
      <Project  />
      <Github />
      <Resume/>
      <Contact />
<Text fontSize={"40px"} color={"green.600"}> Thanks For Visit !</Text>
    </div>
  );
}

export default App;
